import { render, staticRenderFns } from "./homeMb.vue?vue&type=template&id=130356dc&scoped=true"
import script from "./homeMb.vue?vue&type=script&lang=js"
export * from "./homeMb.vue?vue&type=script&lang=js"
import style0 from "./homeMb.vue?vue&type=style&index=0&id=130356dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130356dc",
  null
  
)

export default component.exports